import { render, staticRenderFns } from "./BlockButtonTags.vue?vue&type=template&id=bd09f6ae&"
import script from "./BlockButtonTags.vue?vue&type=script&lang=js&"
export * from "./BlockButtonTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports